import { useEffect, useState } from "react";
import { loginState, configState } from "../lib/State";
import axios from "axios";
import get_token from "../lib/get_token";
import { DataGrid } from "@mui/x-data-grid";
import {Box} from "@mui/material";
import styled from "@emotion/styled";

const Area1 = styled(Box)`
    display: flex;
    div {
        margin-right: 5px;
    }
    margin-bottom: 8px;
`

function CouponEditLog (props) {

    const { login, coupon_seq } = props;    
    const [rows, setRows] = useState([]);
    const columns = [
        { field: "id", headerName: "id", hide: true },
        { field: "regdate", headerName: "등록일" },
        { field: "tname", headerName: "강사명" },
        { field: "class_date", headerName: "예약일" },
        { field: "hour", headerName: "시간" },
        { field: "state", headerName: "상태" },
        { field: "cname", headerName: "센터명" },
    ];
    const [count, setCount] = useState({
        order:0,
        reservation:0,
        cancel:0,
    });

    const load_data = async () => {
        let result = await axios.post(configState.api+'/gympass_admin/coupon_log_one',{
            token: get_token(),
            cid: login.cid,
            mcd : login.mcd,
            level: login.level,
            coupon_seq: coupon_seq,
        });
        setRows(result.data.rows);
        setCount(result.data.count);
    }

    useEffect(() => {
        load_data();        
    },[])

    return <Box>
            <Area1>
                <Box>보유({count.order})</Box>
                <Box>-</Box>
                <Box>예약({count.reservation})</Box>
                <Box>+</Box>
                <Box>취소({count.cancel})</Box>
                <Box>=</Box>
                <Box>잔여({count.order - count.reservation + count.cancel})</Box>
            </Area1>
            <DataGrid      
            sx={{ minHeight: 400}}            
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params)=>{
            }}                        
          />   
    </Box>
}

export default CouponEditLog;